<template>
  <div class="switchView">
    <div class="btn">
      <!-- 问题登记 -->
      <el-button type="primary" style="margin-right: 20px;" @click="add">
        {{ $t('message.aftersaleIssueCreate') }}
      </el-button>
      <!-- 进度汇报填写 -->
      <a href="https://doc.weixin.qq.com/smartsheet/s3_AE8ALQZTAAgCN7lTKZ6W1R6Wle0Wi?scode=AF4AXQfMAA0MVORKYLAf4AkQbcAAs&tab=q979lj&viewId=vukaF8"
        target="_blank" rel="noopener noreferrer" style="margin-right: 20px;" v-if="isAuth(631)"> <el-button
          type="primary">
          进度汇报填写</el-button>
      </a>
      <!-- 运营工单 -->
      <a href="https://doc.weixin.qq.com/smartsheet/form/1_wpXl3MDQAAJbIZ1lVK2YGSdOznDpfZFg_0ff671?journal_source=chat&version=4.1.30.6008&platform=win"
        target="_blank" rel="noopener noreferrer" style="margin-right: 20px;"> <el-button type="primary">
          运营工单</el-button>
      </a>
      <!-- 切换视图 -->
      <a href=" https://doc.weixin.qq.com/smartsheet/form/1_wpXl3MDQAAJbIZ1lVK2YGSdOznDpfZFg_a2dcfe" target="_blank"
        rel="noopener noreferrer" style="margin-right: 20px;"> <el-button type="primary">
          行政工单</el-button>
      </a>
      <!-- 切换视图 -->
      <el-button type="primary" @click="isSwitchView = !isSwitchView"> {{ $t('message.switchView')
      }}</el-button>
    </div>
    <!-- 列表 -->
    <div v-if="isSwitchView">
      <!-- 配货 -->
      <distributionIndex v-if="work_type == 5" />
      <!-- 采购 -->
      <purchaseIndex v-else-if="work_type == 2" />
      <!-- 业务 -->
      <salesmanIndex v-else-if="work_type == 1" />
      <!-- 检品 -->
      <testArticleIndex v-else-if="work_type == 6" />
    </div>
    <!--echarts 图 -->
    <div v-else>
      <homePage />
    </div>
    <!-- 问题登记 -->
    <issueCreate ref="issueCreate" />
  </div>
</template>
<script>

import distributionIndex from './distributionIndex/index'
import purchaseIndex from './purchaseIndex/index'
import salesmanIndex from './salesmanIndex/index'
import testArticleIndex from './testArticleIndex/index'
import homePage from '@/components/echartsList/homePage/index'
import issueCreate from '../siteConfiguration/issueRegistrationList/components/issueCreate.vue'
export default {
  components: {
    distributionIndex,
    purchaseIndex,
    salesmanIndex,
    testArticleIndex,
    homePage,
    issueCreate,

  },
  data() {
    return {
      isSwitchView: true,
      work_type: JSON.parse(localStorage.getItem(
        "japanUserRoleInfo")).role[0].work_type,
    };
  },
  methods: {
    // 新增问题登记
    add() {
      this.$refs.issueCreate.form = {
        client_id: '',
        problem_images: [],
        problem_desc: '',
        problem_category: '',
        product_id: '',
        order_id: '',
        problem_num: '',
        problem_amount: '',
        porder_sn: '',
        order_sn: '',
        porder_detail: [],
        order_detail: []
      }
      this.$refs.issueCreate.radio = 1
      this.$refs.issueCreate.dialogVisible = true
    },
  }
}
</script>

<style lang='scss' scoped>
.switchView {
  position: relative;
  background-color: #fff;

  .btn {
    position: absolute;
    top: 30px;
    right: 40px;
  }

}
</style>